import React from "react";
import SupportCenter from "@/pages/dashboard/SupportCenter";
const SoporteUser = () => <SupportCenter />;
export default SoporteUser;
